<p-tree
  [value]="documentTree"
  selectionMode="single"
  filterPlaceholder="Filter Presets"
  (onNodeSelect)="onNodeSelect($event)"
  [(selection)]="activeSelection"
/>
